<template>
  <div class="row">
    <div class="col-12">
      <f-data-table id="pending-uploads-table"
                    :expanded="false"
                    heading="Pending Uploads"
                    icon="flaticon2-download-2"
                    :data-uri="dataUri"
                    :columns="columns"
                    :selectable-rows="true"
                    :server-side="true">
        <template #_row_controls="props">
          <button v-perms="['api.storage.destroy']" class="btn btn-ss-danger" @click="props.do({ cb: deleteAssets, reload_data: true })">
            <i class="flaticon2-trash" /> Delete
          </button>
        </template>

        <template #actions="props">
          <div class="row-action-cell">
            <div class="btn-group" role="group">
              <button type="button" class="text-center btn btn-sm btn-ss"
                      title="Listen"
                      @click="listen(props.row)">
                <i class="fa fa-play" />
              </button>
              <button type="button" class="text-center btn btn-sm btn-ss"
                      title="Approve"
                      @click="props.do({ cb: () => checkApprove(props.row), reload_data: true})">
                <i class="fa fa-check-circle" />
              </button>
              <button v-perms="['api.storage.destroy']" type="button"
                      class="text-center btn btn-sm btn-ss-danger"
                      title="Delete"
                      @click="props.do({ cb: deleteAssets, reload_data: true})">
                <i class="fa fa-trash" />
              </button>
            </div>
          </div>
        </template>

        <template #user_id="props">
          {{ props.row.user.name }}
        </template>
        <template #uploader_profile="props">
          {{ getUploaderProfileName(props.row.user) }}
        </template>
        <template #created_at="props">
          {{ formatDate(props.row.created_at, `DD/MM/YYYY, hh:mm:ss`) }}
        </template>
      </f-data-table>
    </div>

    <third-party-upload-approve-modal :storage-asset="asset_to_approve" :uploader-profile="uploader_profile" />
    <simple-html5-player v-if="listen_file_path" :file-path="listen_file_path"
                         :bottom-fixed="true" @close-request="() => listen_file_path = ``" />
  </div>
</template>

<script>
import FDataTable from "VuePartials/App/Storage/FDataTable/FDataTable";
import SimpleHtml5Player from "VueComponents/SimpleHtml5Player";
import ThirdPartyUploadApproveModal from "VueModals/ThirdPartyUploadApproveModal";

export default {
  components: { ThirdPartyUploadApproveModal, FDataTable, SimpleHtml5Player },
  data() {
    return {
      approve_modal: 'third-party-upload-approve',
      asset_to_approve: null,
      listen_file_path: ``,
      dataUri: '/api/v1/third-party-uploader?all_uploaders=true',
      columns: [
        {
          display: "Name",
          field: "original_name",
          never_clip: true,
        },
        {
          display: "User",
          field: "user_id",
          sortable: false,
        },
        {
          display: "Profile",
          field: "uploader_profile",
          sortable: false,
        },
        {
          display: "Created At",
          field: 'created_at',
        },
        {
          field: `actions`,
          display: ``,
          sortable: false,
          width: 150,
          never_clip: true,
        },
      ],
    };
  },
  computed: {
    uploader_profile() {
      return this.asset_to_approve?.uploader_profile;
    },
  },
  methods: {
    getUploaderProfileName(user) {
      return user.uploader_profile ? user.uploader_profile.name : "";
    },
    listen(upload) {
      this.listen_file_path = `${window.public_media_path}uploader_storage/${upload.name}`;
    },
    async deleteAssets(...assets) {
      try {
        const res = (await axios.delete(`/api/v1/third-party-uploader`, {
          params: {
            ids: assets.map(asset => asset.uuid).join(`,`),
          },
        })).data;
        if (res.success) {
          toastr.success("Assets(s) Deleted");
          window.EventBus.$emit('storage-table-reload');
        } else {
          toastr.error(`Couldn't delete asset(s)!`);
        }
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
    async checkApprove(row) {
      if (!row.uploader_profile) {
        return this.approveUpload(row);
      }

      this.asset_to_approve = row;

      const modal_res = await this.fireModal(this.approve_modal);
      if (!modal_res.data.success) {
        this.asset_to_approve = null;
        return false;
      }

      return this.approveUpload(row);
    },
    async approveUpload(row) {
      try {
        (await axios.patch(`/api/v1/third-party-uploader/${row.uuid}/approve`)).data;
        toastr.success("Upload Approved");
        window.EventBus.$emit('pending-uploads-table-reload');
        window.EventBus.$emit('storage-table-reload');
      } catch (err) {
        window.handleAxiosError(err);
      }
      this.$modal.hide(this.approve_modal);
      this.asset_to_approve = null;
    },

  },
};
</script>
